<template>
  <custom-callout
    :border-color="statusColor"
    class-main="mt-3 mb-n1"
    :controlled="true"
    :opened="data.isOpen"
    @click:open="onCloseHandler"
  >
    <div class="row py-2 mr-md-0 align-items-center">
      <div class="col-12 col-md-3 text-center">
        <div class="d-flex flex-column font-weight-bold color-black">
          <span
            :class="
              `mb-1 badge badge-pill font-14 pt-2 pb-2 w-70 mx-auto badge-${statusColor}`
            "
          >
            {{ data.serviceStatusDescription | empty }}
          </span>
          <span class="font-16">
            {{ data.requestNumber | empty }}
          </span>
          <div
            v-if="isReturnedToSAEEByHiringLack(data)"
            class=" bg-secondary-41  rounded pt-2 "
          >
            <div class="d-flex align-items-center">
              <em
                class="fa fa-bell-exclamation font-16   color-secondary-40 alert-color"
              />
              <div
                class="font-14 font-weight-normal color-secondary-40 ml-3 alert-color"
              >
                {{ data.determinationReasonDescription }}
              </div>
            </div>
          </div>
          <div
            v-if="data.isReconsideration"
            class=" bg-secondary-41  rounded pt-2 "
          >
            <div class="d-flex align-items-center">
              <em
                class="fa fa-bell-exclamation font-16   color-secondary-40 alert-color"
              />
              <div
                class="font-14 font-weight-normal color-secondary-40 ml-3 alert-color"
              >
                Solicitud de Reconsideración
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="row mb-3">
          <div class="col-12 col-md-4">
            <span class="data-title d-block">Nombre del Estudiante:</span>
            <span class="font-14 color-black">
              {{ data.studentNameSie | empty }}
            </span>
          </div>
          <div class="col-12 col-md-3">
            <span class="data-title d-block">Servicio:</span>
            <span class="font-14 color-black">
              {{ data.serviceDiscipline | empty }}
            </span>
          </div>
          <div class="col-12 col-md-4">
            <span class="data-title d-block">Fecha de Solicitud:</span>
            <span class="font-14 color-black">
              {{ data.requestDate | date("DD/MM/YYYY") }}
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-4">
            <span class="data-title d-block">Fecha de Vencimiento:</span>
            <span class="font-14 color-black">
              {{ data.determinationDate | date("DD/MM/YYYY") }}
            </span>
          </div>
          <div class="col-12 col-md-3">
            <span class="data-title d-block">Días de Vencimiento:</span>
            <span
              v-if="expired"
              class="font-14 font-weight-bold badge badge-pill badge-error color-red border-solid-1 px-3 py-2"
            >
              {{ data.daysCount }} días
            </span>
            <span
              v-else
              class="font-14 font-weight-bold badge badge-pill badge-success color-green border-solid-1 px-3 py-2"
            >
              {{ data.daysCount }} días
            </span>
          </div>
          <div class="col-12 col-md-4">
            <span class="data-title d-block">Nombre del Solicitante:</span>
            <span class="font-14 color-black">
              {{ data.applicantName | empty }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="col-sm-12 col-md-1 mt-3 mt-md-0 d-md-flex align-items-end justify-content-end"
      >
        <div
          v-if="showPrintApproval"
          class="d-flex justify-content-center align-items-center p-2 rounded pt-2"
          :class="{
            'bg-secondary-38': !data.approvedForPrinting,
            'bg-primary-1': data.approvedForPrinting
          }"
          style="height: 38px"
        >
          <em
            class="font-12 p-1"
            :class="{
              'color-gray-6 far fa-flag font-16': !data.approvedForPrinting,
              'color-white fas fa-flag': data.approvedForPrinting
            }"
          />
        </div>
        <drop-down class="ml-2" :items="actionItems" />
      </div>
    </div>
    <template #edition>
      <appointment-notification :data="data" />
      <div class="p-2 mt-1 ">
        <div class="bg-white rounded p-md-3 px-md-4 ">
          <custom-tab v-if="showCustomTab" class="custom-tabs">
            <custom-tab-item
              active
              lazy
              title="Historial de Estatus"
              @click="onOpenStatusHistory()"
            >
              <request-service-status-history
                :items="data.serviceStatusHistory.data"
                :page-count="data.serviceStatusHistory.pageCount"
                @on-load-more="$emit('on-status-history-load-more')"
              />
            </custom-tab-item>
            <custom-tab-item
              v-if="canViewDetermination"
              :active="determinationPanelActive"
              lazy
              title="Determinación"
              @click="onOpenViewDeterminationHandler()"
            >
              <div class="pt-3">
                <request-service-determination
                  :data="data"
                  :is-read-only="true"
                />
              </div>
            </custom-tab-item>
            <custom-tab-item
              :active="
                data.viewToDisplay === requestHistoryViewDisplay.DOCUMENT
              "
              lazy
              title="Documentos de la Solicitud"
              @click="onOpenRequestDocument()"
            >
              <request-document
                :items="requestDocument"
                @on-download-document="onDownloadDocumentHandler"
              />
            </custom-tab-item>
            <custom-tab-item
              title="Bitácora de Seguimiento"
              lazy
              :active="
                data.viewToDisplay === requestHistoryViewDisplay.BITACORA
              "
              @click="onOpenBitacoraAddBlog()"
            >
              <RequestDetail
                :request-number="data.requestNumber"
                :status-color="getHexaColor(data.serviceStatusId)"
                :status-name="data.serviceStatusDescription"
              />
              <AddBlogItem
                :comment-types="blogCommentTypes"
                :request-id="data.requestServiceId"
                @save="$emit('save-blog-item', $event)"
              />
            </custom-tab-item>
            <custom-tab-item
              title="Historial de Seguimiento"
              lazy
              :active="
                data.viewToDisplay ===
                  requestHistoryViewDisplay.BITACORA_HISTORY
              "
              @click="onOpenBitacoraHistory()"
            >
              <RequestDetail
                :request-number="data.requestNumber"
                :status-color="getHexaColor(data.serviceStatusId)"
                :status-name="data.serviceStatusDescription"
              />
              <BitacoraHistory
                :blog-items="blogItems"
                @download="downloadFile($event)"
                @load-bitacora="fetchBitacoraHistory()"
                @remove-blog="removeBlog"
              />
            </custom-tab-item>
          </custom-tab>
          <div v-if="!showCustomTab" class="py-3">
            <request-service-determination
              :data="data"
              :is-read-only="false"
              @cancel="onCloseHandler"
              @save="onServiceSaved($event, data)"
            />
          </div>
        </div>
      </div>
    </template>
  </custom-callout>
</template>

<script>
import CustomCallout from "custom-callout";
import DropDown from "dropdown";
import { CustomTab, CustomTabItem } from "custom-tabs";
import RequestServiceStatusHistory from "./RequestServiceStatusHistory.vue";
import RequestDocument from "./RequestDocument.vue";
import ServiceStatuses from "@/utils/constants/student/provisionalRemedyAnswerStatus.js";
import ServiceStatusColors from "@/utils/constants/rp/requestServiceStatusColors.js";
import RequestServiceDetermination from "./determination/RequestServiceDetermination.vue";
import requestHistoryViewDisplay from "@/utils/constants/rp/requestHistoryViewDisplay.js";
import ServiceTypes from "@/utils/constants/rp/serviceTypes.js";
import AppointmentNotification from "./AppointmentNotification.vue";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";
import { getRequestServicesById } from "@/modules/student-answer-rp/api.js";
import peiServices from "@/services/pei/general";
import DeterminationReasons from "@/utils/constants/student/determinationReason.js";
import AddBlogItem from "@/components/pei/ref/components/AddBlogItem";
import RequestDetail from "@/components/pei/ref/components/RequestDetail";
import BitacoraHistory from "@/components/pei/ref/components/BitacoraHistory";
import { deleteBitacoraItems, getBitacoraItems } from '@/modules/referral/api';
import documentsService from "@/services/documents";
import thrpiesAdmissionStatuses from "@/utils/constants/thrpiesAdmissionStatuses.js";
const DEFAULT_HISTORY_CONTRACT_PAGE_SIZE = 5;

export default {
  name: "RequestServiceResult",
  components: {
    CustomCallout,
    DropDown,
    CustomTab,
    CustomTabItem,
    RequestServiceDetermination,
    RequestServiceStatusHistory,
    RequestDocument,
    AppointmentNotification,
    AddBlogItem,
    RequestDetail,
    BitacoraHistory
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {}
    },
    blogCommentTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showCustomTab: true,
      showDeterminationPanel: false,
      blogItems: []
    };
  },
  computed: {
    actionItems() {
      return [
        {
          label: "Ver Determinación",
          icon: "fas fa-eye color-green",
          border: this.canApproveService ? "" : "bottom",
          visible: this.canViewDetermination,
          click: () => this.onOpenViewDeterminationHandler()
        },
        {
          label: "Aprobar",
          icon: "fas fa-check-circle color-green",
          border:
            this.canCancelService || this.canObjectService ? "" : "bottom",
          visible: this.canApproveService,
          click: () => {
            this.onOpenChangeStatusHandler(false, ServiceStatuses.Aprobado);
          }
        },
        {
          label: "Aprobar Asistente",
          icon: "fas fa-check-circle color-green",
          border:
            this.canCancelService || this.canObjectService ? "" : "bottom",
          visible: this.canApproveServiceAssistant,
          click: () => {
            this.onOpenChangeStatusHandler(false, ServiceStatuses.Aprobado);
          }
        },
        {
          label: "Objetar",
          icon: "fas fa-gavel color-red",
          border: this.canCancelService ? "" : "bottom",
          visible: this.canObjectService,
          click: () => {
            this.onOpenChangeStatusHandler(false, ServiceStatuses.Objetado);
          }
        },
        {
          label: "Cancelar",
          icon: "fas fa-times-circle color-red",
          visible: this.canCancelService,
          click: () => {
            this.onOpenChangeStatusHandler(false, ServiceStatuses.Cancelado);
          }
        },
        {
          label: "Regresar Estatus",
          icon: "fas fa-undo color-green",
          border: "bottom",
          visible: this.canReturnToPreviousStatus,
          click: () => {
            this.onOpenReturnToPreviousStatusHandler(false);
          }
        },
        {
          label: "Historial de Solicitud",
          icon: "fas fa-clock color-green",
          click: () => this.onOpenStatusHistory()
        },
        {
          label: "Historial de Bitácora",
          icon: "fas fa-clock color-green",
          border: "bottom",
          click: () => this.onOpenBitacoraHistory()
        },
        {
          label: "Documentos",
          icon: "fas fa-file-search color-green mr-n1 pr-2",
          border: "bottom",
          click: () => this.onOpenRequestDocument()
        },
        {
          label: "Imprimir Carta",
          icon: "fas fa-file-download color-green",
          visible: this.canDownloadLetter,
          click: () => this.$emit("on-get-determination-letter")
        },
        {
          label: "Descargar Solicitud",
          icon: "fas fa-file-download color-green",
          border: "bottom",
          click: () => this.$emit("on-get-request-service-report")
        },
        {
          label: "Bitácora de Seguimiento RP",
          icon: "fas fa-file-signature color-green",
          click: () => this.onOpenBitacoraAddBlog()
        }
      ];
    },
    statusColor() {
      switch (this.data.serviceStatusId) {
        case ServiceStatuses.Nuevo:
          return ServiceStatusColors.Yellow;
        case ServiceStatuses.Aprobado:
          return ServiceStatusColors.GreenLight;
        case ServiceStatuses.Cancelado:
          return ServiceStatusColors.Brown;
        case ServiceStatuses.Objetado:
          return ServiceStatusColors.Purple;
        default:
          return null;
      }
    },
    expired() {
      return this.data.daysCount < 0 || this.data.daysCount > 20;
    },
    isServiceAssistantAndStatusNew() {
      const isServiceAssistant = this.serviceType === ServiceTypes.Assistant;
      const isNew = this.data.serviceStatusId === ServiceStatuses.Nuevo;

      return isServiceAssistant && isNew;
    },
    canApproveServiceAssistant() {
      return (
        this.isServiceAssistantAndStatusNew &&
        this.userHasPermissions("rempro.admin.action.approveservice")
      );
    },
    canApproveService() {
      const hasPermissions =
        this.userHasPermissions("menu.rempro.view.approveservice") ||
        this.userHasPermissions("menu.academic.view.approveservice");

      const isNotApproved =
        this.data.serviceStatusId !== ServiceStatuses.Aprobado &&
        this.data.serviceStatusId !== ServiceStatuses.Objetado &&
        this.data.serviceStatusId !== ServiceStatuses.Cancelado;

      const hasReconsiderationPermissions =
        this.userHasPermissions("rempro.providers.requestreconsideration") ||
        this.userHasPermissions("academic.providers.requestreconsideration");

      return (
        hasPermissions &&
        isNotApproved &&
        !this.isServiceAssistantAndStatusNew &&
        (!this.data.isReconsideration || hasReconsiderationPermissions)
      );
    },
    canCancelService() {
      const hasPermissions = this.userHasPermissions(
        "menu.rempro.view.cancelservice"
      );
      const isNotCancelled =
        this.data.serviceStatusId !== ServiceStatuses.Cancelado &&
        this.data.serviceStatusId !== ServiceStatuses.Nuevo;

      if (this.data.isReconsideration) {
        return (
          hasPermissions &&
          isNotCancelled &&
          (this.userHasPermissions("rempro.providers.requestreconsideration") ||
            this.userHasPermissions(
              "academic.providers.requestreconsideration"
            ))
        );
      } else {
        return hasPermissions && isNotCancelled;
      }
    },
    canObjectService() {
      const hasPermissions = this.userHasPermissions(
        "menu.rempro.view.objectservice"
      );
      const isNotObjected =
        this.data.serviceStatusId !== ServiceStatuses.Objetado &&
        this.data.serviceStatusId !== ServiceStatuses.Aprobado &&
        this.data.serviceStatusId !== ServiceStatuses.Cancelado;

      if (this.data.isReconsideration) {
        return (
          hasPermissions &&
          isNotObjected &&
          (this.userHasPermissions("rempro.providers.requestreconsideration") ||
            this.userHasPermissions(
              "academic.providers.requestreconsideration"
            ))
        );
      } else {
        return hasPermissions && isNotObjected;
      }
    },
    canReturnToPreviousStatus() {
      const hasPermissions = this.userHasPermissions(
        "menu.rempro.view.returntopreviousstatus"
      );

      const Statuses = [
        ServiceStatuses.Aprobado,
        ServiceStatuses.Objetado,
        ServiceStatuses.Cancelado
      ];

      const canDoIt = Statuses.includes(this.data.serviceStatusId);

      if (this.data.isReconsideration) {
        return (
          hasPermissions &&
          canDoIt &&
          (this.userHasPermissions("rempro.providers.requestreconsideration") ||
            this.userHasPermissions(
              "academic.providers.requestreconsideration"
            ))
        );
      } else {
        return hasPermissions && canDoIt;
      }
    },
    canViewDetermination() {
      return !!this.data.isDeterminated;
    },
    determinationPanelActive() {
      return this.showDeterminationPanel && this.canViewDetermination;
    },

    canDownloadLetter() {
      return (
        this.data.serviceStatusId === ServiceStatuses.Aprobado ||
        this.data.serviceStatusId === ServiceStatuses.Objetado
      );
    },
    canGetAppointment() {
      return (
        this.serviceType === ServiceTypes.Evaluation ||
        this.serviceType === ServiceTypes.Therapy
      );
    },
    requestHistoryViewDisplay() {
      return requestHistoryViewDisplay;
    },
    serviceType() {
      return this.data.serviceTypeId;
    },
    serviceContractHistory() {
      return this.data.serviceContractHistory?.data || [];
    },
    requestDocument() {
      return this.data.requestDocument || [];
    },
    showServiceContractPagination() {
      return (
        this.serviceContractPagination.count > 0 &&
        this.serviceContractPagination.pageCount > 1
      );
    },
    serviceContractPagination() {
      let pagination = this.data.serviceContractHistory;
      delete pagination.data;
      pagination = {
        ...pagination,
        pageSize: DEFAULT_HISTORY_CONTRACT_PAGE_SIZE
      };
      return pagination;
    },
    showPrintApproval() {
      return [ServiceStatuses.Approved, ServiceStatuses.Objetado].includes(
        this.data?.serviceStatusId
      );
    }
  },
  methods: {
    async removeBlog(blogId){
      let hasError = false;
      await deleteBitacoraItems(blogId).catch(error => {
        const errorMsg = error.data && error.data.message
          ? error.data.message
          : error.response.data.message;
        this.ShowToast("Error", errorMsg, "error");
        hasError = true;
      });

      if(hasError) return;

      this.ShowToast(
              "Proceso exitoso",
              "Se Eliminó Comentario de Bitácora satisfactoriamente",
              "success"
            );

      // refresh history
      await this.fetchBitacoraHistory();
    },
    async downloadFile(fileId) {
      await documentsService.downloadDocumentByAttachmentIdOrDocumentId(fileId);
    },
    async fetchBitacoraHistory() {
      const { data } = await getBitacoraItems(this.data.requestServiceId);
      this.blogItems = data;
    },
    getHexaColor(serviceStatusId) {
      switch (serviceStatusId) {
        case ServiceStatuses.Nuevo:
          return "#f8ea8";
        case ServiceStatuses.Aprobado:
          return "#A3E5B3";
        case ServiceStatuses.Cancelado:
          return "#d5b89a";
        case ServiceStatuses.Objetado:
          return "#ddb3d7";
        default:
          return null;
      }
    },
    async onServiceSaved(saved, row) {
      if (saved) {
        const { data } = await getRequestServicesById(row.requestId);
        this.showCustomTab = true;
        this.$emit("on-save-determination", data);
      }
    },
    onCloseHandler() {
      this.showCustomTab = true;
      this.$emit("on-open-close");
    },
    onOpenStatusHistory() {
      this.showDeterminationPanel = false;
      this.$emit("on-open-status-history");
    },
    onOpenBitacoraHistory() {
      this.showDeterminationPanel = false;
      this.$emit("on-open-bitacora-history");
    },
    onOpenRequestDocument() {
      this.showDeterminationPanel = false;
      this.$emit("on-open-request-document");
    },
    onOpenBitacoraAddBlog() {
      this.showDeterminationPanel = false;
      this.$emit("on-open-bitacora-addblog");
    },
    onChangePageHandler(page) {
      this.onOpenContractHistory(page);
    },
    onOpenViewDeterminationHandler() {
      this.showCustomTab = true;
      this.showDeterminationPanel = true;
      this.$emit(
        "on-open-view-determination",
        this.data.serviceStatusId,
        this.serviceType
      );
    },
    onDownloadDocumentHandler({ documentId }) {
      if (documentId) {
        peiServices.downloadDocumentByAttachmentId(documentId);
      }
    },
    onOpenChangeStatusHandler(showCustomTabValue = false, statusId) {
      this.showCustomTab = showCustomTabValue;
      this.$emit("on-open-change-status", statusId, this.serviceType);
    },
    onOpenReturnToPreviousStatusHandler(showCustomTabValue = false) {
      this.showCustomTab = showCustomTabValue;
      this.$emit("on-open-return-to-previous-status");
    },
    isReturnedToSAEEByHiringLack(data) {
      return (
        data.determinationReasonId ===
        DeterminationReasons.ReturnedToSAEEByHiringLack
      );
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";
.edit-Row {
  padding-top: 10px !important;
}

.border-radius--light {
  border-radius: 0px !important;
}

.badge-green-light {
  background-color: map-get($colors, "green-light");
}
.badge-purple {
  background-color: map-get($colors, "violet");
}
.badge-yellow {
  background-color: map-get($colors, "yellow");
}
.badge-brown {
  background-color: map-get($colors, "brown");
}
.border-solid-1 {
  border: 1px solid;
}
.badge-success {
  background-color: map-get($colors, "secondary-1");
}
.badge-error {
  background-color: map-get($colors, "red-light");
}
.color-secondary-40 {
  color: #b0690b;
}
</style>
